import { LayoutSidebarLeftIcon, LayoutSidebarRightIcon } from '../../common/ui/icons';
import { closeSideMenu, isSideMenuClosedInStorage, openSideMenu } from '../domain/menu-storage';
import { useCommonStore } from '../../common/data/store';
import { useEffect } from 'react';

export const SIDE_MENU_CLOSED_BODY_CLASS = 'side-menu-closed';

const ToggleSidebarButton = () => {

    const isSideMenuClosed = useCommonStore(store => store.isSideMenuClosed);
    const setIsSideMenuClosed = useCommonStore(store => store.setIsSideMenuClosed);

    useEffect(() => {
        if(!isSideMenuClosedInStorage()) return;
        document.body.classList.add(SIDE_MENU_CLOSED_BODY_CLASS);
    }, []);

    const toggleSideMenuHandler = () => {

        if(isSideMenuClosed) {
            openSideMenu();
            document.body.classList.remove(SIDE_MENU_CLOSED_BODY_CLASS);
        }
        else{
            closeSideMenu();
            document.body.classList.add(SIDE_MENU_CLOSED_BODY_CLASS);
        }

        setIsSideMenuClosed(!isSideMenuClosed);
    };

    return (
        <button
            onClick={ toggleSideMenuHandler }
            className="ml-auto hidden md:block"
            type="button">

            {
                !isSideMenuClosed &&
                <LayoutSidebarLeftIcon
                    color={ '#9BA9BB' }
                    strokeWidth={ 1.2 }
                    fill={ '#202C3D' }
                    size={ 26 }
                />
            }

            {
                isSideMenuClosed &&
                <LayoutSidebarRightIcon
                    color={ '#9BA9BB' }
                    strokeWidth={ 1.2 }
                    fill={ '#202C3D' }
                    size={ 26 }
                />
            }
        </button>
    )
};

export default ToggleSidebarButton;